import React from 'react'
import {LoginModal} from 'common/styleguide/LoginModal'
import {Overlay} from 'common/styleguide/Overlay'

export const LoginModalOverlay = ({maxWidth = 410, maxHeight = 800, onRequestClose, ...props}) => (
  <Overlay
    maxWidth={maxWidth}
    maxHeight={maxHeight}
    onRequestClose={onRequestClose}>
    <LoginModal {...props} onRequestClose={onRequestClose} />
  </Overlay>
)
